import React, { Component } from "react";
import { Form } from "semantic-ui-react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import './styles.scss';

class ShiftControlForm extends Component {
    constructor() {
        super();
        let _currentYear = new Date().getFullYear();
        let _yearArr = [];
        for (let i = _currentYear - 9; i <= _currentYear; i++) {
            _yearArr.push(i);
        } 
        let monthArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        this.state = {
            errInputMsg: {},
            monthArr: monthArr,
            currentYear:'',
            currentMonth: '',
            yearArr: _yearArr

        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            errInputMsg: nextProps.isError,
            currentYear: nextProps.currentValueYear,
            currentMonth : nextProps.currentValueMonth,
        });
    }

    handleChangeSelect = (evt) => {
        this.props.changeSelect(evt);
    }

    render() {
        const { t, totalOT, projectDataValue } = this.props;
        const { monthArr, currentYear, currentMonth, yearArr } = this.state;
        return (
            <div className="employee-form inquiry-form shift-form">
                <Form>
                    <Form.Group inline>
                        <label>{t("labels.periodYear")}</label>
                        <select name="year" className="small-select select-margin-right year-select"
                            value={currentYear}
                            onChange={e => { this.handleChangeSelect(e) }}
                            >
                            {yearArr.map((option, index) => {
                                    return (
                                        <option value={option} key={index}>{option}</option>
                                    )
                                })
                            }
                        </select>
                        <label>{t("labels.periodMonth")}</label>
                        <select name="month" className="small-select"
                            value={currentMonth}
                            onChange={e => { this.handleChangeSelect(e) }}
                            >
                            {monthArr.map((option, index) => {
                                    return (
                                    <option value={("0" + (index + 1)).slice(-2)} key={index}>{option}</option>
                                    )
                                })
                            }
                        </select>
                    </Form.Group>
                </Form>
            </div>
        );
    }
}

const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => ({
})

export default compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
)(ShiftControlForm);
